import {
  useContext,
  createContext,
  Children,
  cloneElement,
  useState,
} from 'react';

type AccordioContextProps = {
  items: { [key: number]: string };
  setItem: (index: number) => void;
};

const AccordionContext = createContext<AccordioContextProps>({
  items: {},
  setItem: () => null,
});

/**
 * AccordionProvider.
 */
export const AccordionProvider = ({ children, isMulti }: any) => {
  // FIXME: any
  const [items, setItems] = useState(
    Children.toArray(children).reduce(
      (sum, _, index) => ({ ...sum, [index]: false }),
      {},
    ),
  );

  /**
   * SetItem.
   */
  const setItem = (index: number) => {
    if (!isMulti) {
      const d = Object.keys(items).reduce(
        (sum, curr) => ({ ...sum, [curr]: false }),
        {},
      );
      setItems({ ...d, [index]: !(items as any)[index] }); // FIXME: any
    } else {
      setItems({ ...items, [index]: !(items as any)[index] }); // FIXME: any
    }
  };

  return (
    <AccordionContext.Provider value={{ items, setItem }}>
      {Children.map(children, (child, index) => {
        return cloneElement(child, { index, key: index });
      })}
    </AccordionContext.Provider>
  );
};

/**
 * UseAccordion.
 */
export const useAccordion = (): AccordioContextProps =>
  useContext(AccordionContext);

/**
 * UseAccordionItem.
 */
export const useAccordionItem = (index: number) => {
  const { items } = useAccordion();

  return items[index];
};
